import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetAusgangsrechnungenMutation, useStorniereAusgangsrechnungenMutation } from '../../api/FakturaAPI';
import { formatToEuroDate } from '../../util/DateUtils';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';

export default function Ausgangsrechnungen() {

    type satz = {
        uid: string,
        rechnungsnummer: string,
        rechnungsdatum: Date,
        preisnetto: number,
        mwstBetrag: number,
        mwstSatz: number,
        brutto: number,
        storniert: boolean,
        rechnungsempfaenger: {
            name1: string,
            name2: string,
            strasse: string,
            plz: string,
            ort: string
        }
    }

    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [getListe] = useGetAusgangsrechnungenMutation();
    const [stoniereApi] = useStorniereAusgangsrechnungenMutation();
    const [liste, setListe] = useState<satz[]>([]);

    const lade = () => {

        getListe().unwrap()
            .then((data) => setListe(data));

    }

    const stornieren = (uid: string) => {
        stoniereApi(uid).unwrap()
            .then(() => lade());
    }

    useEffect(() => {
        lade();
    }, []);

    return (
        <>
            <div>

                <LandingpageHeader />

                <div style={{ padding: "20px" }}>

                    <div className="container">
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <button
                                onClick={() => {
                                    navigate({
                                        pathname: "/",
                                        search: ""
                                    });
                                }}

                                style={{ marginBottom: "20px" }}
                                className=' btn btn-outline-primary'
                            >
                                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                            </button>
                        </div>

                        <h3>Ausgangsrechnungen</h3>

                        <p>
                            Anzahl {liste.length}
                        </p>

                        <table className="table">

                            <tr>
                                <th>Storniert</th>
                                <th>Rechnungsdatum</th>
                                <th>Rechnungsnummer</th>
                                <th>Netto</th>
                                <th>Mwst Satz</th>
                                <th>Mwst Betrag</th>
                                <th>Brutto</th>
                                <th>Name1</th>
                                <th>Name2</th>
                                <th>Strasse</th>
                                <th>Ort</th>
                                <th>Option</th>
                            </tr>

                            {liste.map((e, index) => <>
                                <tr key={index}>
                                    <td>{e.storniert ? "JA" : ""}</td>
                                    <td>{formatToEuroDate(e.rechnungsdatum)}</td>
                                    <td>{e.rechnungsnummer}</td>
                                    <td>{e.preisnetto}</td>
                                    <td>{e.mwstSatz}</td>
                                    <td>{e.mwstBetrag}</td>
                                    <td>{e.brutto}</td>
                                    <td>{e.rechnungsempfaenger?.name1}</td>
                                    <td>{e.rechnungsempfaenger?.name2}</td>
                                    <td>{e.rechnungsempfaenger?.strasse}</td>
                                    <td>{e.rechnungsempfaenger?.ort}</td>
                                    <td>
                                        {!e.storniert &&
                                            <button className='btn btn-danger' onClick={() => { stornieren(e.uid) }}>Stornieren</button>
                                        }
                                    </td>
                                </tr>
                            </>)}

                        </table >

                    </div>
                </div>
            </div >
            <Footer />
        </>
    );
}
